import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, CheckCircle2, Info, TriangleAlert, X } from "lucide-react";

import IconButton from "./IconButton";

const icons = { error: AlertCircle, info: Info, success: CheckCircle2, warning: TriangleAlert };

export const Toast = ({ children, onDismiss, title, type = "info" }) => {
  const Icon = icons[type];
  return (
    <div className={`wsm-toast wsm-toast--${type}`} role={type === "error" ? "alert" : "status"}>
      <Icon aria-hidden="true" className="wsm-toast__icon" />
      <div className="wsm-toast__content"><strong>{title}</strong>{children && <div>{children}</div>}</div>
      <IconButton aria-label={`Dismiss ${title} notification`} icon={X} onClick={onDismiss} size="compact" />
    </div>
  );
};

Toast.propTypes = {
  children: PropTypes.node,
  onDismiss: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["error", "info", "success", "warning"]),
};

export const ToastRegion = ({ children, label = "Notifications" }) => (
  <section aria-label={label} className="wsm-toast-region">{children}</section>
);
ToastRegion.propTypes = { children: PropTypes.node.isRequired, label: PropTypes.string };
